/**
 * MapDialog
 * 
 * @Author: Focci
 * @Date: 2023-08-18 11:36:01
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-18 11:36:01
 */

'use client'

import useDialog from '@hook/useDialog'
import useTracking from '@hook/useTracking'
import dynamic from 'next/dynamic'
import { forwardRef, useCallback, useImperativeHandle } from 'react'
import { useTranslations } from 'next-intl'
import { Button, CircularProgress } from '@comp/material'

const LocationMapDialogBody = dynamic(() => import('./LocationMapDialogBody'), {
  ssr: false,
  loading: () => (
    <div className="absolute inset-1/2 -translate-1/2"><CircularProgress /></div>
  )
})

function LocationMapDialog({
  tabName,
  locationBarOptionValue = '',
  house = {},
  showTrigger = true,
}, ref) {
  const th = useTranslations('house')
  const { openDialog, Dialog } = useDialog()
  const { pushTrackListingClick } = useTracking()

  const handleOpenDialog = useCallback(() => {
    openDialog()
    
    // 添加统计事件
    tabName === 'schoolPanel' && pushTrackListingClick('school_zones-map', house)
    tabName === 'development' && pushTrackListingClick('for_developers-map', house)
  }, [house, openDialog, pushTrackListingClick, tabName])
  
  useImperativeHandle(ref, () => ({ openDialog: handleOpenDialog }), [handleOpenDialog])
  
  return (
    <>
      {showTrigger && (
        <Button size="large" onClick={handleOpenDialog}>
          <span className="px-8">{th('showOnMap')}</span>
        </Button>
      )}
      <Dialog width="80rem" headWidth="80rem">
        <div className="flex -m-4 h-[40rem] relative border bg-cf0 absolute inset-0">
          <LocationMapDialogBody 
            tabName={tabName}
            locationBarOptionValue={locationBarOptionValue}
            house={house}
          />
        </div>
      </Dialog>
    </>
  )
}

export default forwardRef(LocationMapDialog)
